import { render } from "./DataLoader.vue?vue&type=template&id=3a5ca706&scoped=true"
import script from "./DataLoader.vue?vue&type=script&lang=js"
export * from "./DataLoader.vue?vue&type=script&lang=js"

import "./DataLoader.vue?vue&type=style&index=0&id=3a5ca706&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5ca706"]])

export default __exports__